export default {
  "OptionsCardHeaderContainer": "_OptionsCardHeaderContainer_hhjh7_1",
  "OptionTextContainer": "_OptionTextContainer_hhjh7_2",
  "OptionsItemsWrapper": "_OptionsItemsWrapper_hhjh7_8",
  "OptionWrapper": "_OptionWrapper_hhjh7_13",
  "OptionText": "_OptionText_hhjh7_2",
  "OptionTextLight": "_OptionTextLight_hhjh7_22",
  "MoreButtonContainer": "_MoreButtonContainer_hhjh7_36"
};import "ni:sha-256;ycOY1flI1VxzyznC2Te0x2qLsowgI64J8JnzKnkbK-M";